import React from "react";
import { PlayerContextType, Song } from "../libs/Interfaces";
import { playlistData } from "../libs/Dummy";
import { storage } from "../firebase/config";

const PlayerContext = React.createContext<PlayerContextType>({
  currentIndex: () => 0,
  playlist: playlistData["selectsongs"],
  setSong: (song: Song) => console.log(song),
  status: "BUFFERING",
  play: () => console.log("PLAY"),
  pause: () => console.log("PAUSE"),
  next: () => console.log("NEXT"),
  prev: () => console.log("PREV"),
  setPlaylist: (playlist: Song[]) => console.log("SET", playlist),
  seek: (percent: number) => console.log(percent),
  percent: () => 0,
  stat: {
    min: 0,
    max: 0,
    current: 0,
    text: "00:00",
  },
  song: playlistData["selectsongs"][0],
  getNextIndex: () => 0,
  getPrevIndex: () => 0,
  seekToTime: (time: number) => console.log(time),
});

export function usePlayer() {
  return React.useContext(PlayerContext);
}

export function PlayerProvider({ children }: { children: any }) {
  const [audio] = React.useState(new Audio());

  const [playlist, changePlaylist] = React.useState(
    playlistData["selectsongs"]
  );
  const [status, setStatus] = React.useState<
    "PLAYING" | "PAUSED" | "BUFFERING"
  >("BUFFERING");
  const [stat, setstat] = React.useState({
    min: 0,
    max: 0,
    current: 0,
    text: "00:00",
  });

  function currentIndex() {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return -1;
    let index = audio.getAttribute("index");
    if (index) return parseInt(index);
    return -1;
  }

  function setIndex(index: number) {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    audio.setAttribute("index", `${index}`);
  }

  function onmetaLoaded(ev: Event) {
    // setStatus("PAUSED");
    audio.play();
    //alert("LOADED");
  }
  function onplay(ev: Event) {
    setStatus("PLAYING");
    setNotification();
  }
  function onpause(ev: Event) {
    setStatus("PAUSED");
  }
  function onend(ev: Event) {
    setStatus("PAUSED");
    next();
  }

  function getDownloadUrl(id: string) {
    return storage.ref(`songs/${id}.mp3`).getDownloadURL();
  }

  async function _play() {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    audio.src = await getDownloadUrl(playlist[currentIndex()].id);
    //audio.load();
    // audio.removeAttribute("src");
    audio.load();
  }

  function timetext(s: number) {
    if (isNaN(s)) return "00 : 00";
    s = Math.floor(s);
    let mins = Math.floor(s / 60);
    let secs = s % 60;
    let text = "";
    if (mins < 10) text += "0";
    text += `${mins} : `;
    if (secs < 10) text += "0";
    text += `${secs}`;
    return text;
  }

  function updateSeekbar() {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    //if (audio.children.length === 0) return;
    if (!audio.src) return;
    setstat({
      min: 0,
      max: isNaN(audio.duration) ? 0 : audio.duration,
      current: audio.currentTime,
      text: timetext(audio.currentTime),
    });
    if (navigator.mediaSession) {
      if (navigator.mediaSession.setPositionState) {
        navigator.mediaSession.setPositionState({
          duration: isNaN(audio.duration) ? 0 : audio.duration,
          playbackRate: audio.playbackRate,
          position: audio.currentTime,
        });
      }
    }
  }

  React.useEffect(() => {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    audio.setAttribute("index", "0");
    audio.preload = "metadata";
    audio.addEventListener("loadedmetadata", onmetaLoaded);
    audio.addEventListener("playing", onplay);
    audio.addEventListener("pause", onpause);
    audio.addEventListener("ended", onend);
    audio.addEventListener("timeupdate", updateSeekbar);
    //let interval = setInterval(updateSeekbar, 1000);
    //return () => clearInterval(interval);
  }, []);

  function setSong(song: Song) {
    let index = playlist.findIndex((v) => v.id === song.id);
    if (index === -1) return;
    if (song.id === playlist[currentIndex()].id) return;
    stop();
    setIndex(index);
    play();
  }
  function play() {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    //if (audio.children.length === 0) return _play();
    if (!audio.src) return _play();
    return audio.play();
  }
  function pause() {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    audio.pause();
  }
  function next() {
    stop();
    setIndex(getNextIndex());
    return play();
  }
  function prev() {
    stop();
    let index = currentIndex();
    setIndex(index - 1 < 0 ? playlist.length - 1 : index - 1);
    play();
  }
  function getNextIndex() {
    let index = currentIndex() + 1;
    return index < playlist.length ? index : 0;
  }
  function getPrevIndex() {
    let index = currentIndex() + 1;
    return index - 1 < 0 ? playlist.length - 1 : index - 1;
  }
  function seekToTime(time: number) {
    audio.currentTime = time;
  }
  function stop() {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    audio.removeAttribute("src");
    audio.load();
  }
  function setPlaylist(newplaylist: Song[]) {
    stop();
    setIndex(0);
    changePlaylist(playlist);
    //play();
  }
  function seek(perc: number) {
    if (perc < 0 || perc > 100) return;
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return;
    audio.currentTime = (audio.duration * perc) / 100;
  }
  function percent() {
    //let audio = document.getElementsByTagName("audio")[0];
    if (!audio) return 0;
    if (audio.children.length === 0) return 0;
    return (audio.currentTime / audio.duration) * 100;
  }

  function setNotification() {
    if (navigator.mediaSession) {
      let index = currentIndex();
      navigator.mediaSession.metadata = new MediaMetadata({
        title: playlist[index].name,
        artist: playlist[index].artist,
        album: playlist[index].playlist,
        artwork: [
          { src: playlist[index].image, sizes: "300x300", type: "image/jpg" },
          { src: playlist[index].image, sizes: "96x96", type: "image/png" },
          { src: playlist[index].image, sizes: "128x128", type: "image/png" },
          { src: playlist[index].image, sizes: "192x192", type: "image/png" },
          { src: playlist[index].image, sizes: "256x256", type: "image/png" },
          { src: playlist[index].image, sizes: "384x384", type: "image/png" },
          { src: playlist[index].image, sizes: "512x512", type: "image/png" },
        ],
      });
      navigator.mediaSession.setActionHandler("play", play);
      navigator.mediaSession.setActionHandler("pause", pause);
      navigator.mediaSession.setActionHandler("seekto", (details) => {
        let time = details.seekTime;
        //let audio = document.getElementsByTagName("audio")[0];
        if (!audio) return;
        seekToTime(time);
      });
      navigator.mediaSession.setActionHandler("previoustrack", prev);
      navigator.mediaSession.setActionHandler("nexttrack", next);
    }
  }

  return (
    <PlayerContext.Provider
      value={{
        playlist,
        currentIndex,
        status,
        setPlaylist,
        setSong,
        play,
        pause,
        next,
        prev,
        seek,
        percent,
        stat,
        song: playlist[currentIndex()],
        getNextIndex,
        seekToTime,
        getPrevIndex,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
}
